import { gql } from '@apollo/client';
const UPDATE_PRODUCT_VARIANT = gql `
  mutation UpdateProductVariant(
    $productVariantId: ID!
    $colorName: String
    $chainColor: String
    $tapeColor: String
    $sliderColor: String
    $previewColor: String
    $sizeName: String
    $price: Float
    $currencyId: ID
  ) {
    updateProductVariant(
      productVariantId: $productVariantId
      colorName: $colorName
      chainColor: $chainColor
      tapeColor: $tapeColor
      sliderColor: $sliderColor
      previewColor: $previewColor
      sizeName: $sizeName
      price: $price
      currencyId: $currencyId
    ) {
      productVariant {
        id
        size {
          id
          name
        }
        color {
          id
          name
          chain
          tape
          slider
          previewColor
        }
        currentPrice {
          id
          price
          currency {
            id
            isoCode
            name
          }
        }
        priceHistory {
          edges {
            node {
              createdDate
              modifiedDate
              id
              price
              currency {
                id
                isoCode
              }
            }
          }
        }
        product {
          id
          dataHash
          snapshots {
            edges {
              node {
                id
                isUpToDate
              }
            }
          }
        }
      }
    }
  }
`;
export default UPDATE_PRODUCT_VARIANT;
